"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CourierBoxSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        borderTop: "1px solid ".concat(theme.palette.grey[200]),
        width: "calc(100% - ".concat(theme.spacing(6), ")"),
        padding: theme.spacing(3, 0, 4, 0),
        margin: theme.spacing(3, 0, 0, 3)
    };
});
const CourierBoxWrapper = (0, _mui.styled)('div')({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
});
const Radio = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        marginRight: theme.spacing(3)
    };
});
const SkeletonImage = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(-1, 0, 3, 0)
    };
});
const SkeletonPrice = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(3)
    };
});
const DeliveryInfo = (0, _mui.styled)('div')({
    marginLeft: 'auto'
});
const CourierBoxSkeleton = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        "data-testid": getTestId(_models.TestId.SkeletonCourierBox),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CourierBoxWrapper, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Radio, {
                    animation: "wave",
                    variant: "circular",
                    width: 20,
                    height: 20
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonImage, {
                            animation: "wave",
                            variant: "text",
                            width: 150,
                            height: 30
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                            animation: "wave",
                            variant: "text",
                            width: 120,
                            height: 24
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DeliveryInfo, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonPrice, {
                            animation: "wave",
                            variant: "text",
                            width: 65,
                            height: 24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                            animation: "wave",
                            variant: "text",
                            width: 65,
                            height: 24
                        })
                    ]
                })
            ]
        })
    });
};
exports.CourierBoxSkeleton = CourierBoxSkeleton;
